import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, IconButton, Menu, MenuItem, ListItemIcon, ListItemText} from '@material-ui/core';
import MoreVert from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import PersonIcon from '@material-ui/icons/Person';

class SipUsersListEditor_ extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            selectedID: null,
            menuAnchor: null
        }
    }

    handleUserSelect(userID){
        this.setState({selectedID: userID})
    }

    isSelected(userID){
        let selected = userID === this.state.selectedID
        return selected
    }

    getUserStyle(userID){
        let style = {
            background: this.isSelected(userID) ? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleMenuClick(event, itemID){
        this.setState({menuAnchor: event.currentTarget, menuItemID: itemID});
        event.stopPropagation();
    }

    handleMenuClose(){
        this.menuAnchor = null;
        this.setState({menuAnchor: null});
        return null;
    }

    handleMenuItemClick(action, userID){
        const itemID = userID ? userID : this.state.menuItemID
        this.handleMenuClose();
        this.props.onAction({type: action, userID: itemID})
    }

    render(){
        const {t} = this.props

        //this.props.users.sort(sortByLogin)
        //console.log(this.props.users)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            icon:{
                width: 30
            },
            addIcon: {
                color: 'white'
            }
        };

        let users = this.props.users

        return(
            <>
                <Paper style={styles.paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{...styles.head, ...styles.icon}}></TableCell>
                                <TableCell style={{...styles.head, width:'30%'}}>{t('Name')}</TableCell>
                                <TableCell style={{...styles.head}}>{t('SipAddress')}</TableCell>
                                <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="more" component="span"
                                        style={styles.addIcon}
                                        onClick={()=>{this.handleMenuItemClick('SIP_USER_EDITOR_OPEN_ADD')}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {users.map((user) => 
                            <TableRow key={user.ID} 
                                    onClick={()=>{this.handleUserSelect(user.ID)}}
                                    onDoubleClick={()=>{this.handleMenuItemClick('SIP_USER_EDITOR_OPEN_EDIT', user.ID)}}
                                    style={this.getUserStyle(user.ID)}>
                                <TableCell style={styles.icon}>
                                    <PersonIcon color={this.isSelected(user.ID)?"primary":"inherit"}/>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {user.Name}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {user.URI}
                                </TableCell>

                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="add" component="span"
                                        onClick={event=>this.handleMenuClick(event, user.ID)}>
                                        <MoreVert />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                        <Menu anchorEl={this.state.menuAnchor} keepMounted
                            open={Boolean(this.state.menuAnchor)} onClose={this.handleMenuClose.bind(this)}>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('SIP_USER_EDITOR_OPEN_EDIT')}}>
                                <ListItemIcon color="primary"><EditIcon/></ListItemIcon> 
                                <ListItemText primary={t('EditUser')+'...'} />
                            </MenuItem>
                            <MenuItem onClick={()=>{this.handleMenuItemClick('SIP_USER_EDITOR_DELETE')}}>
                                <ListItemIcon><DeleteForeverIcon/></ListItemIcon>
                                <ListItemText primary={t('DeleteUser')} />
                            </MenuItem>
                        </Menu>
                    </Table>
                </Paper>
            </>
        )

    }

}

export const SipUsersListEditor = withTranslation()(SipUsersListEditor_);